import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

import { gradientBackgrounds } from "@/components/AIComponents/AiComponents.style";

const { heading4Obj } = typographyStyles;
const { colors } = constants;
const white = colors.ui.white[500];

export const containerWrapperCss: CSSObject = {
  padding: "16px",
  minWidth: "580px",
  background: gradientBackgrounds[100],
  borderRadius: "16px",
  height: "100%",
  overflowX: "hidden",
  overflowY: "auto",
};

export const previewContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
};

export const templateContainerCss: CSSObject = {
  width: "100%",
  height: "100%",
  background: white,
};

export const templateFormCss: CSSObject = {
  height: "100%",
};

export const previewHeaderTextStyles: CSSObject = {
  ...heading4Obj,
  margin: "5px 0 12px",
};

export const previewHeaderActionsStyles: CSSObject = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "8px",
};
